<template>
  <el-dialog class="preview-img-wrap" :modal="false" append-to-body v-dialogDrag :title="title" :before-close="closeDialog" :visible.sync="visible" :width="width" center :close-on-click-modal="false">
    <el-card>
      <iframe v-if="fileSuffix.includes('pdf')  || fileSuffix.includes('PDF')" :src='imgSrc' frameborder="0" :width="iframeWidth" :height="iframeHeight"></iframe>
      <img v-else-if="imgFlag || fileSuffix.includes( 'jpg')||fileSuffix.includes('png')||fileSuffix.includes('jpeg')" :src='imgSrc' alt="">
      <div v-else alt="">非图片或pdf格式，无法预览</div>
    </el-card>
    <!-- <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">关闭</el-button>
    </span> -->
  </el-dialog>
</template>

<script>
''.includes()
  export default {
    name: "preview-img",
    data() {
      return {

      }
    },
    computed: {
      iframeWidth() {
        if(this.width == '660px' || this.fileSuffix === 'pdf' ||  this.fileSuffix === 'PDF'){
          return '100%';
        }else if(parseInt(this.width)) {
          return (parseInt(this.width) - 60) + 'px'
        }
        return '440px'
      }
    },
    props: {
      imgSrc: {//图片路径
        type: String,
      },
      imgFlag: {//是否为图片格式文件 如果传true 则不需要传fileSuffix
        type: Boolean,
        default: false
      },
      visible: {//弹窗是否可见
        type: Boolean
      },
      width: {//弹窗宽度 如果为pdf格式 单位应为px
        type: String,
        default: '500px'
      },
      fileSuffix: {//预览的文件后缀名
        type: String,
        default:''
      },
      title: {//弹窗标题
        type: String,
        default: '图片预览'
      },
      iframeHeight: {
        type: String,
        default: '500px'
      },
    },
    created() {

    },
    methods: {
      //关闭预览弹窗
      closeDialog(){
        this.$emit('close')
      }
    }
  }
</script>

<style lang="scss">
.preview-img-wrap {
  .el-card__body {
    padding: 0;
  }
  img {
    width: 100%;
  }

}
</style>
